import { Injectable } from '@angular/core';
import { Command, StateService, CommandInterfaces } from 'flux-core';
import { DataStore } from 'flux-store';
import { ModelSubscriptionManager } from 'flux-subscription';
import { AbstractMessageCommand } from 'flux-connection';

/**
 * This is the command to get archived projects.
 */
@Injectable()
@Command()
export class GetArchivedProjects extends AbstractMessageCommand {

    public static get implements(): Array<CommandInterfaces> {
        return [
            'IMessageCommand',
            'IProjectCommand',
        ];
    }

    constructor(
            protected dataStore: DataStore,
            protected modelSubManager: ModelSubscriptionManager,
            protected state: StateService<any, any> ) {
                super() /* istanbul ignore next */;
    }

    public execute(): any {
        return true;
    }
}

Object.defineProperty( GetArchivedProjects, 'name', {
    value: 'GetArchivedProjects',
});
